/*
  Registers GSAP ScrollTrigger globally so every Oblivion section's pin/scrub
  and reveal animations work against Horizon's actual scroll container.

  Two real bugs found here, found by loading the live site in Playwright and
  inspecting ScrollTrigger's own instance list rather than guessing:

  1. This script must run BEFORE every section's own oblivion-*.js (each one
     checks `typeof window.gsap` and silently no-ops if it isn't loaded yet).
     Deferred scripts execute in document order, so this tag has to be placed
     ahead of every section in the HTML (now: in <head>) — it was previously
     at the end of <body>, i.e. after every section script that depends on
     it, so literally zero ScrollTriggers were ever created anywhere on the
     site.

  2. **Scroller (fixed 2026-09-19)**: Horizon's base.css only makes
     `.page-wrapper` the scroll container at >=990px (html/body locked at
     `overflow:hidden`); below 990px the window scrolls. The 2026-09-05 fix
     removed the `scroller` override after testing MOBILE only, which left
     every ScrollTrigger watching a window that never moves on desktop
     (all pins/reveals frozen, sections invisible). Rather than juggling a
     per-breakpoint `scroller`, oblivion-tokens.css now undoes Horizon's
     desktop lock so the WINDOW scrolls at every width, and ScrollTrigger's
     default (window) is correct everywhere. Always test desktop (>=990px)
     AND mobile after touching scroll behaviour.

  Lenis (smooth-scroll) was tried here earlier and reverted for the same
  `.page-wrapper` reason (now known to be a wrong assumption) — worth
  revisiting with the real window/document scroller if smooth-scroll is
  still wanted.
*/
(function () {
  if (window.oblivionScrollInitialized) return;
  window.oblivionScrollInitialized = true;

  function init() {
    if (typeof window.gsap === 'undefined') return;
    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    if (ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
      // On iOS Safari, the URL bar hiding/showing mid-scroll fires resize
      // events that make ScrollTrigger re-measure pinned sections while the
      // user is mid-gesture, which is what caused the exploded-view pin to
      // never engage (or drop out) on a real phone. This tells ScrollTrigger
      // to ignore the small resizes that trigger does, not full orientation
      // changes.
      ScrollTrigger.config({ ignoreMobileResize: true });
    }
    document.dispatchEvent(new CustomEvent('oblivion:scroll-ready'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
